
  const sentryInfo = {
  "environment": "production",
  "release": "production@1793822642041"
};
  export default sentryInfo;
